import { FontAwesome5 } from '@expo/vector-icons';
import React from 'react';
import { StyleSheet } from 'react-native';
import { useTheme } from 'react-native-paper';
import type { Icon } from 'react-native-vector-icons/Icon';

export type DropdownIconProps = { isOpen: boolean } & Omit<
  React.ComponentProps<typeof Icon>,
  'name'
>;

export const DropdownIcon: React.FC<DropdownIconProps> = ({
  isOpen,
  color,
  size = 10,
}) => {
  const { colors } = useTheme();

  return (
    <FontAwesome5
      name={isOpen ? 'chevron-up' : 'chevron-down'}
      color={color ?? colors.dark1}
      style={styles.chevronIcon}
      size={size}
    />
  );
};

const styles = StyleSheet.create({
  chevronIcon: {
    padding: 10,
  },
});
